import { render } from "./BecomeDealer.vue?vue&type=template&id=4f7fd3a2&ts=true"
import script from "./BecomeDealer.vue?vue&type=script&lang=ts"
export * from "./BecomeDealer.vue?vue&type=script&lang=ts"

import "./BecomeDealer.vue?vue&type=style&index=0&id=4f7fd3a2&lang=scss"

import exportComponent from "/Users/lorenzoli/ForkHome/marlu/marlu-store-locator-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__